export const formatScoreScaledToDisplay = (score: number) => {
  return (score * 100).toFixed(0);
};
